import { theme } from '@snsw-gel/react';
import { vars } from '@snsw-gel/theming';

export const multiSelectStylesGel3 = (hasError, width = '100%') => ({
  control: (provided, state) => ({
    ...provided,
    marginTop: '0.25rem',
    border: hasError ? `2px solid ${theme.colors.shiraz}` : `1px solid ${vars.colors.neutral.grey100}`,
    borderRadius: '6px',
    padding: '0.25rem 0',
    outline: state.isFocused ? `3px solid ${vars.colors.border.focus}` : 'unset',
    outlineOffset: state.isFocused ? '3px' : 'unset',
    boxShadow: 'unset',
    // maxWidth: vars.layouts.inputWidths.xl,
    width: width,
  }),
  menu: (provided) => ({
    ...provided,
    border: `1px solid ${vars.colors.neutral.grey100}`,
    marginTop: '-0.2ex',
    width: width,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? 'rgba(0, 38, 100, 0.1)' : theme.colors.white,
    color: vars.colors.neutral.grey100,
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: '13px 16px',
  }),
  multiValue: (provided) => ({
    ...provided,
    fontWeight: '450',
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    color: state.isFocused ? theme.colors.white : theme.colors.black,
    ':hover': {
      backgroundColor: theme.colors.brand.snswPrimaryRed,
      color: theme.colors.white,
    },
    ':active': {
      backgroundColor: theme.colors.shiraz,
      color: theme.colors.white,
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: vars.colors.neutral.grey100,
    svg: {
      width: '16px',
      height: '16px',
      transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0deg)',
      margin: state.selectProps.menuIsOpen ? '-5px 0 0 -20px' : 0,
    },
    'svg path': {
      d: 'path("M16 5a1 1 0 00-1.71-.71L8 10.59l-6.29-6.3A1.004 1.004 0 00.29 5.71l7 7a1 1 0 001.42 0l7-7A1 1 0 0016 5z")',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    color: vars.colors.neutral.grey200,
    svg: {
      width: '12px',
      height: '12px',
      margin: state.selectProps.menuIsOpen ? '0 26px 0 0' : '0 10px 0 0',
      strokeWidth: '0.8px',
    },
    'svg path': {
      d: 'path("M15 16a1 1 0 01-.71-.29l-14-14A1 1 0 011.71.29l14 14a1 1 0 010 1.42A1 1 0 0115 16z M1 16a1 1 0 01-.71-.29 1 1 0 010-1.42l14-14a1 1 0 111.42 1.42l-14 14A1 1 0 011 16z")',
    },
    'svg:hover': {
      color: theme.colors.shiraz,
    },
  }),
});

export const multiSelectThemeGel3 = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#22272B',
    neutral10: '#EBEBEB',
    neutral30: '#22272B',
    neutral50: '#22272B', // placeholder text
    dangerLight: theme.colors.shiraz,
  },
});
